
const getCircularReplacer = () => {
  const seen = new WeakSet();
  return (key: string, value: any) => {
    if (typeof value === "object" && value !== null) {
      if (seen.has(value)) {
        return;
      }
      seen.add(value);
    }
    return value;
  };
};

export const safeJsonStringify = (obj: any, space?: number): string => {
  return JSON.stringify(obj, getCircularReplacer(), space);
};
